import { atomWithStorage } from 'jotai/utils';

/**
 * Whether the renderer's module hover tooltip is shown. Shared by every renderer instance, so
 * toggling it on one sheet applies everywhere. Persisted.
 */
export const hoverInfoEnabledAtom = atomWithStorage('cad-renderer-hover-info-enabled', true, undefined, {
	getOnInit: true,
});
